import { Module } from "vuex";

class State {}

const dataModule: Module<State, any> = {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {},
};

export default dataModule;
